import { render, staticRenderFns } from "./FormulaListSix.vue?vue&type=template&id=37df58a1&scoped=true&"
import script from "./FormulaListSix.vue?vue&type=script&lang=js&"
export * from "./FormulaListSix.vue?vue&type=script&lang=js&"
import style0 from "./FormulaListSix.vue?vue&type=style&index=0&id=37df58a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df58a1",
  null
  
)

export default component.exports